import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
function JobsEngineerModal({ show, onClose, onFormSubmit, ProjectMemberList, data, EngineerData, tableId }) {

    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    const formatDate = (dateStr) => {
        // Convert YYYY/MM/DD to YYYY-MM-DD
        return dateStr ? dateStr.replace(/\//g, '-') : '';
    };

    const parseDate = (dateStr) => {
        // Convert YYYY-MM-DD to YYYY/MM/DD
        return dateStr ? dateStr.replace(/-/g, '/') : '';
    };

    const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };

    const getCurrentTime = () => {
        const now = new Date();
        return now.toTimeString().split(' ')[0].slice(0, 5);
    };

    const getOneHourLaterTime = () => {
        const now = new Date();
        now.setHours(now.getHours() + 1);
        return now.toTimeString().split(' ')[0].slice(0, 5);
    };

    const [formData, setFormData] = useState({
        EngineerTimeID: 0,
        IsTimeSepcified: '0',
        PayRateID: 'BASC',
        DepartBaseDate: '',
        DepartBaseTime: '',
        ReturnBaseDate: '',
        ReturnBaseTime: '',
        StartDate: getCurrentDate(),
        StartTime: getCurrentTime(),
        EndDate: getCurrentDate(),
        EndTime: getOneHourLaterTime(),
        HoursTravel: '0',
        HoursDate: '1'
    });

    const [errors, setErrors] = useState({});
    const [timePickerVisible, setTimePickerVisible] = useState(false);

    useEffect(() => {
        if (EngineerData) {
            const hasDepartBaseDate = EngineerData.DepartBaseDate && EngineerData.DepartBaseDate.trim() !== '';
            setFormData({
                EngineerTimeID: EngineerData.EngineerTimeID,
                IsTimeSepcified: hasDepartBaseDate ? '1' : '0',
                PayRateID: EngineerData.PayRateID || 'BASC',
                DepartBaseDate: parseDate(EngineerData.DepartBaseDate) || '',
                DepartBaseTime: EngineerData.DepartBaseTime || '',
                ReturnBaseDate: parseDate(EngineerData.ReturnBaseDate) || '',
                ReturnBaseTime: EngineerData.ReturnBaseTime || '',
                StartDate: parseDate(EngineerData.StartDate) || getCurrentDate(),
                StartTime: EngineerData.StartTime || getCurrentTime(),
                EndDate: parseDate(EngineerData.EndDate) || getCurrentDate(),
                EndTime: EngineerData.EndTime || getOneHourLaterTime(),
                HoursTravel: EngineerData.HoursTravel || '0',
                HoursDate: EngineerData.HoursDate || '',
                Other: EngineerData.Other || '',
                UserID: EngineerData.UserID
            });
        }
        else {
            setFormData({
                EngineerTimeID: '0',
                IsTimeSepcified: '0',
                PayRateID: 'BASC',
                DepartBaseDate: '',
                DepartBaseTime: '',
                ReturnBaseDate: '',
                ReturnBaseTime: '',
                StartDate: getCurrentDate(),
                StartTime: getCurrentTime(),
                EndDate: getCurrentDate(),
                EndTime: getOneHourLaterTime(),
                HoursTravel: '0',
                HoursDate: '1',
                Other: ""
            });
        }
    }, [EngineerData, data.UserID]);

    useEffect(() => {
        const calculateHoursTravel = () => {
            if (
                formData.DepartBaseDate && formData.DepartBaseTime &&
                formData.ReturnBaseDate && formData.ReturnBaseTime &&
                !isNaN(Date.parse(`${formatDate(formData.DepartBaseDate)}T${formData.DepartBaseTime}`)) &&
                !isNaN(Date.parse(`${formatDate(formData.ReturnBaseDate)}T${formData.ReturnBaseTime}`))
            ) {
                /*    const beginTravelDateTime = new Date(`${formatDate(formData.DepartBaseDate)}T${formData.DepartBaseTime}`);
                    const endTravelDateTime = new Date(`${formatDate(formData.ReturnBaseDate)}T${formData.ReturnBaseTime}`);
    
                    const diffInMilliseconds = Math.abs(endTravelDateTime - beginTravelDateTime);
                    const diffInHours = diffInMilliseconds / (1000 * 60 * 60);
    
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        HoursTravel: diffInHours.toFixed(2)
                    }));*/

                const beginTravelDateTime = new Date(`${formatDate(formData.DepartBaseDate)}T00:00:00`);
                const endTravelDateTime = new Date(`${formatDate(formData.ReturnBaseDate)}T00:00:00`);

                const diffInMillisecondss = Math.abs(endTravelDateTime - beginTravelDateTime);
                const diffInHourss = (diffInMillisecondss / (1000 * 60 * 60) / 24) + 1;


                const startTimeString = `${formatDate('2000/01/01')}T${formData.DepartBaseTime}`;
                const endTimeString = `${formatDate('2000/01/01')}T${formData.ReturnBaseTime}`;


                const startTime = new Date(startTimeString);
                const endTime = new Date(endTimeString);

                if (isNaN(startTime.getTime()) || isNaN(endTime.getTime())) {
                    console.error('Invalid date(s):', startTimeString, endTimeString);
                } else {
                    // Calculate the difference in milliseconds
                    const differenceInMs = endTime - startTime;

                    // Convert the difference from milliseconds to hours
                    const differenceInHours = differenceInMs / (1000 * 60 * 60);
                    const TotalHourse = diffInHourss * differenceInHours;
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        HoursTravel: TotalHourse.toFixed(2)
                    }));
                }
            }
        };

        const calculateHoursDate = () => {
            if (
                formData.StartDate && formData.StartTime &&
                formData.EndDate && formData.EndTime &&
                !isNaN(Date.parse(`${formatDate(formData.StartDate)}T${formData.StartTime}`)) &&
                !isNaN(Date.parse(`${formatDate(formData.EndDate)}T${formData.EndTime}`))
            ) {


                const beginStartDateTime = new Date(`${formatDate(formData.StartDate)}T00:00:00`);
                const endDateTime = new Date(`${formatDate(formData.EndDate)}T00:00:00`);

                const diffInMillisecondss = Math.abs(endDateTime - beginStartDateTime);
                const diffInHourss = (diffInMillisecondss / (1000 * 60 * 60) / 24) + 1;


                const startTimeString = `${formatDate('2000/01/01')}T${formData.StartTime}`;
                const endTimeString = `${formatDate('2000/01/01')}T${formData.EndTime}`;


                const startTime = new Date(startTimeString);
                const endTime = new Date(endTimeString);

                if (isNaN(startTime.getTime()) || isNaN(endTime.getTime())) {
                    console.error('Invalid date(s):', startTimeString, endTimeString);
                } else {
                    // Calculate the difference in milliseconds
                    const differenceInMs = endTime - startTime;

                    // Convert the difference from milliseconds to hours
                    const differenceInHours = differenceInMs / (1000 * 60 * 60);
                    const TotalHourse = 1 * differenceInHours;
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        HoursDate: TotalHourse.toFixed(2)
                    }));
                }
            }
        };

        calculateHoursTravel();
        calculateHoursDate();
    }, [
        formData.DepartBaseDate, formData.DepartBaseTime,
        formData.ReturnBaseDate, formData.ReturnBaseTime,
        formData.StartDate, formData.StartTime,
        formData.EndDate, formData.EndTime
    ]);

    const handleRadioChange = (event) => {
        const newValue = event.target.value;

        if (newValue === '1') {
            // Update the date and time fields to current date and time
            setFormData(prevData => ({
                ...prevData,
                IsTimeSepcified: '1',
                DepartBaseDate: getCurrentDate(),
                DepartBaseTime: getCurrentTime(),
                ReturnBaseDate: getCurrentDate(),
                ReturnBaseTime: getOneHourLaterTime(),
            }));
        } else {
            // Set IsTimeSepcified to 0 without changing date and time fields
            setFormData(prevData => ({
                ...prevData,
                IsTimeSepcified: '0',
                DepartBaseDate: '',
                DepartBaseTime: '',
                ReturnBaseDate: '',
                ReturnBaseTime: '',
            }));
        }
    };

    const handleRadio1Change = (event) => {
        const { value } = event.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            PayRateID: value
        }));
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };

    const handleTimeChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
        setTimePickerVisible(false);
    };

    const handleTimeClick = () => {
        setTimePickerVisible(true);
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        setErrors({});

        let validationErrors = {};

        if (formData.ReturnBaseDate && formData.DepartBaseDate) {
            if (new Date(formatDate(formData.ReturnBaseDate)) < new Date(formatDate(formData.DepartBaseDate))) {
                validationErrors.ReturnBaseDate = 'End Travel Date must be greater than or equal to Begin Travel Date';
            }
        }
        if (formData.ReturnBaseTime && formData.DepartBaseTime) {
            if (formData.ReturnBaseTime <= formData.DepartBaseTime) {
                validationErrors.ReturnBaseTime = 'End Travel Time must be greater than Begin Travel Time.';
            }
        }

        if (formData.EndDate && formData.StartDate) {
            if (new Date(formatDate(formData.EndDate)) < new Date(formatDate(formData.StartDate))) {
                validationErrors.EndDate = 'End Date must be greater than or equal to Start Date';
            }
        }
        if (formData.StartTime && formData.EndTime) {
            if (formData.EndTime <= formData.StartTime) {
                validationErrors.EndTime = 'End Travel Time must be greater than Begin Travel Time.';
            }
        }

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const engineer = ProjectMemberList.find((project) => {
            const userId = formData.UserID || data.UserID;
            return project.UserID === userId;
        });
        const newEntries = [];

        const startDate = new Date(formatDate(formData.StartDate));
        const endDate = new Date(formatDate(formData.EndDate));
        debugger;

        for (let date = startDate; date <= endDate; date.setDate(date.getDate() + 1)) {
            const currentEntryDate = new Date(date);
            debugger;
            const newEntry = {
                ...formData,
                tableId: tableId,
                UserID: engineer?.UserID || '',
                DisplayName: engineer?.DisplayName || '',
                DepartBaseDate: formatDate(formData.DepartBaseDate),
                ReturnBaseDate: formatDate(formData.ReturnBaseDate),
                StartDate: formatDate(currentEntryDate.toISOString().split('T')[0]),
                EndDate: formatDate(currentEntryDate.toISOString().split('T')[0])
            };

            // Add the entry to the array
            newEntries.push(newEntry);
        }

        // Pass the array of new entries to the onFormSubmit handler
        debugger;
        onFormSubmit(newEntries);

        // Reset form data
        setFormData({
            EngineerTimeID: '0',
            IsTimeSepcified: '0',
            PayRateID: 'BASC',
            DepartBaseDate: '',
            DepartBaseTime: '',
            ReturnBaseDate: '',
            ReturnBaseTime: '',
            StartDate: getCurrentDate(),
            StartTime: getCurrentTime(),
            EndDate: getCurrentDate(),
            EndTime: getOneHourLaterTime(),
            HoursTravel: '0',
            HoursDate: '1'
        });
        onClose();
    };

    const handleCheckboxChange = (event) => {
        const { checked } = event.target;
        setFormData({
            ...formData,
            Other: checked
        });
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }

    return (
        
            <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1" aria-labelledby="partModalLabel" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden={!show} >
                <div className="modal-dialog modal-lg">
                    <Draggable handle=".modal-content" onStart={handleStart}
                        cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="partModalLabel">Add/Edit Times</h5>
                                <button type="button" className="btn-close" onClick={onClose} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginTop": "10px", "marginRight": "0px" }}>
                                        <label htmlFor="IsTimeSepcified" className="col-sm-2 col-form-label"></label>
                                        <div className="col-sm-2">
                                            <div>
                                                <input className="form-check-input" type="radio" name="IsTimeSepcified" value="0" checked={formData.IsTimeSepcified === '0'} onChange={handleRadioChange} />
                                            </div>
                                            <div style={{ marginLeft: "15px" }}>
                                                <label className=" col-form-label">No Times</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div>
                                                <input className="form-check-input" type="radio" name="IsTimeSepcified" value="1" checked={formData.IsTimeSepcified === '1'} onChange={handleRadioChange} />
                                            </div>
                                            <div style={{ marginLeft: "15px" }}>
                                                <label className="col-form-label">Time Specified</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                        <label htmlFor="DepartBaseDate" className="col-sm-2 col-form-label">Begin Travel Date:<span style={{ color: "red" }}>*</span></label>
                                        <div className="col-sm-4">

                                            <input type="date" className="form-control" name="DepartBaseDate" value={formatDate(formData.DepartBaseDate) || ''} onChange={handleChange} disabled={formData.IsTimeSepcified === '0'} />
                                            {errors.DepartBaseDate && <div style={{ color: 'red' }}>{errors.DepartBaseDate}</div>}
                                        </div>
                                        <label htmlFor="DepartBaseTime" className="col-sm-2 col-form-label">Begin Travel Time:</label>
                                        <div className="col-sm-4">
                                            <input type="time" className="form-control" name="DepartBaseTime" value={formData.DepartBaseTime || ''} onChange={handleTimeChange} onClick={handleTimeClick} disabled={formData.IsTimeSepcified === '0'} />
                                            {errors.DepartBaseTime && <div style={{ color: 'red' }}>{errors.DepartBaseTime}</div>}
                                        </div>
                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                        <label htmlFor="ReturnBaseDate" className="col-sm-2 col-form-label">End Travel Date:<span style={{ color: "red" }}>*</span></label>
                                        <div className="col-sm-4">
                                            <input type="date" className="form-control" name="ReturnBaseDate" value={formatDate(formData.ReturnBaseDate) || ''} onChange={handleChange} disabled={formData.IsTimeSepcified === '0'} />
                                            {errors.ReturnBaseDate && <div style={{ color: 'red' }}>{errors.ReturnBaseDate}</div>}
                                        </div>
                                        <label htmlFor="ReturnBaseTime" className="col-sm-2 col-form-label">End Travel Time:</label>
                                        <div className="col-sm-4">
                                            <input type="time" className="form-control" name="ReturnBaseTime" value={formData.ReturnBaseTime || ''} onChange={handleTimeChange} onClick={handleTimeClick} disabled={formData.IsTimeSepcified === '0'} />
                                            {errors.ReturnBaseTime && <div style={{ color: 'red' }}>{errors.ReturnBaseTime}</div>}
                                        </div>
                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                        <label htmlFor="HoursTravel" className="col-sm-2 col-form-label"></label>
                                        <div className="col-sm-4"></div>
                                        <label htmlFor="HoursTravel" className="col-sm-2 col-form-label">Hours Travel:</label>
                                        <div className="col-sm-4">
                                            <input type="text" className="form-control" name="HoursTravel" value={formData.HoursTravel || ''} onChange={handleChange} disabled={formData.IsTimeSepcified === '0'} />
                                            {errors.HoursTravel && <div style={{ color: 'red' }}>{errors.HoursTravel}</div>}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                        <label htmlFor="StartDate" className="col-sm-2 col-form-label">Start Date:<span style={{ color: "red" }}>*</span></label>
                                        <div className="col-sm-4">
                                            <input type="date" className="form-control" name="StartDate" value={formatDate(formData.StartDate) || ''} onChange={handleChange} />
                                            {errors.StartDate && <div style={{ color: 'red' }}>{errors.StartDate}</div>}
                                        </div>
                                        <label htmlFor="StartTime" className="col-sm-2 col-form-label">Start Time:</label>
                                        <div className="col-sm-4">
                                            <input type="time" className="form-control" name="StartTime" value={formData.StartTime || ''} onChange={handleTimeChange} onClick={handleTimeClick} />
                                            {errors.StartTime && <div style={{ color: 'red' }}>{errors.StartTime}</div>}
                                        </div>
                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                        <label htmlFor="EndDate" className="col-sm-2 col-form-label">End Date:<span style={{ color: "red" }}>*</span></label>
                                        <div className="col-sm-4">
                                            <input type="date" className="form-control" name="EndDate" value={formatDate(formData.EndDate) || ''} onChange={handleChange} />
                                            {errors.EndDate && <div style={{ color: 'red' }}>{errors.EndDate}</div>}
                                        </div>
                                        <label htmlFor="EndTime" className="col-sm-2 col-form-label">End Time:</label>
                                        <div className="col-sm-4">
                                            <input type="time" className="form-control" name="EndTime" value={formData.EndTime || ''} onChange={handleTimeChange} onClick={handleTimeClick} />
                                            {errors.EndTime && <div style={{ color: 'red' }}>{errors.EndTime}</div>}
                                        </div>
                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                        <label htmlFor="HoursDate" className="col-sm-2 col-form-label"></label>
                                        <div className="col-sm-4"></div>
                                        <label htmlFor="HoursDate" className="col-sm-2 col-form-label">Hours:</label>
                                        <div className="col-sm-4">
                                            <input type="text" className="form-control" name="HoursDate" value={formData.HoursDate || ''} onChange={handleChange} />
                                            {errors.HoursDate && <div style={{ color: 'red' }}>{errors.HoursDate}</div>}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                        <label htmlFor="PayRateID" className="col-sm-2 col-form-label"></label>
                                        <div className="col-sm-2">
                                            <div>
                                                <input className="form-check-input" type="radio" name="PayRateID" value="BASC" checked={formData.PayRateID === 'BASC'} onChange={handleRadio1Change} />
                                            </div>
                                            <div style={{ marginLeft: "15px" }}>
                                                <label className="col-form-label">Basic</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div>
                                                <input className="form-check-input" type="radio" name="PayRateID" value="OVRT" checked={formData.PayRateID === 'OVRT'} onChange={handleRadio1Change} />
                                            </div>
                                            <div style={{ marginLeft: "15px" }}>
                                                <label className="col-form-label">Overtime</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div>
                                                <input className="form-check-input" type="radio" name="PayRateID" value="DBLT" checked={formData.PayRateID === 'DBLT'} onChange={handleRadio1Change} />
                                            </div>
                                            <div style={{ marginLeft: "15px" }}>
                                                <label className="col-form-label">Double Time</label>
                                            </div>

                                        </div>
                                        <div className="col-sm-2">
                                            <div>
                                                <label htmlFor="PayRateID" className="col-form-label">Other:</label>
                                            </div>
                                            <div style={{ marginLeft: "18px" }}>
                                                <input className="form-check-input" type="checkbox" name="Other" checked={formData.Other} onChange={handleCheckboxChange} />

                                            </div>
                                        </div>
                                    </div>

                                    <div className="modal-footer">
                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Draggable>
                </div>
            </div>
        
    );
}

export default JobsEngineerModal;
